import moment from 'moment';
import { createReducer } from 'typesafe-actions';
import withJobs from '../../_core/job/reducers';
import {
    IAnnex6V2Store,
} from './@types';
import annex6V2Actions, {
    EAnnex6V2Constants,
    TAnnex6V2Actions,
} from './actions';
import { marpolUtils } from '../marpol';

const bdnFilterMonth = moment().format('yyyy-MM');
const bdnStartDate = marpolUtils.getMonthStart(bdnFilterMonth);
const bdnEndDate = marpolUtils.getMonthEnd(bdnFilterMonth);

const defaultState: IAnnex6V2Store = {
    _jobs: {},
    currentOperation: undefined,
    records: {
        byIds: {},
        ids: [],
    },
    filter: {
        startDate: moment().subtract(7, 'days').toDate(),
        endDate: moment().add(1, 'day').toDate(),
        shownRecords: 'ALL',
    },
    currentWeekReport: {
        recordedOperations: {},
        pendingApprovalsCount: 0,
        totalRecords: 0,
        strikedOffCount: 0,
        pendingVerificationsCount: 0,
        isLastRecordStrikedOff: false,
        isItSundayFirstHalf: false,
        isItSundaySecondHalf: false,
        isWeekEndDatePassed: false,
    },
    previousWeekReport: {
        recordedOperations: {},
        pendingApprovalsCount: 0,
        totalRecords: 0,
        strikedOffCount: 0,
        pendingVerificationsCount: 0,
        isLastRecordStrikedOff: false,
        isItSundayFirstHalf: false,
        isItSundaySecondHalf: false,
        isWeekEndDatePassed: false,
    },
    bdnReports: [],
    bdnRecord: undefined,
    bdnFilter: {
        startDate: bdnStartDate, // on initial load
        endDate: bdnEndDate,
        sortOrder: 'desc',
    },
    bdnDisposalStatus: undefined,
};
const annex6V2Reducers = createReducer<IAnnex6V2Store, TAnnex6V2Actions>(
    defaultState
)
    .handleAction(
        annex6V2Actions.document.historySet,
        function historySet(state, action) {
            return {
                ...state,
                records: action.payload.history,
            };
        }
    )
    .handleAction(
        annex6V2Actions.document.setFilter,
        function setFilter(state, action) {
            return {
                ...state,
                filter: action.payload.filter,
            };
        }
    );

export default withJobs<IAnnex6V2Store>(
    EAnnex6V2Constants.FEATURE,
    defaultState,
    annex6V2Reducers
);
